import React from 'react';
import PasswordInput from 'src/components/PasswordInput';
import PasswordRequirementsList from 'src/components/PasswordRequirementsList';
import { PasswordRequirements } from 'src/SharedCustomHooks/UsePasswordRequirements/usePasswordRequirements';
import './new-password-fields.scss';

interface NewPasswordFieldsProps {
  password: string;
  confirmPassword: string;
  onPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  requirements: PasswordRequirements;
  passwordsMismatch: boolean;
  passwordLabel?: string;
  confirmPasswordLabel?: string;
  oldPassword?: string;
  onOldPasswordChange?: (value: string) => void;
  oldPasswordLabel?: string;
}

const NewPasswordFields = ({
  password,
  confirmPassword,
  onPasswordChange,
  onConfirmPasswordChange,
  requirements,
  passwordsMismatch,
  passwordLabel = 'New Password',
  confirmPasswordLabel = 'Confirm Password',
  oldPassword,
  onOldPasswordChange,
  oldPasswordLabel = 'Current Password',
}: NewPasswordFieldsProps) => {
  const showOldPassword: boolean =
    oldPassword !== undefined && onOldPasswordChange !== undefined;

  return (
    <div className="new-password-fields">
      {showOldPassword ? (
        <PasswordInput
          value={oldPassword ?? ''}
          onChange={onOldPasswordChange!}
          label={oldPasswordLabel}
          block
        />
      ) : null}

      <PasswordInput
        value={password}
        onChange={onPasswordChange}
        label={passwordLabel}
        block
      />

      <PasswordInput
        value={confirmPassword}
        onChange={onConfirmPasswordChange}
        label={confirmPasswordLabel}
        block
      />

      <div
        className={`new-password-fields-error${
          passwordsMismatch ? ' new-password-fields-error-visible' : ''
        }`}
        aria-hidden={!passwordsMismatch}
      >
        Passwords do not match.
      </div>

      <PasswordRequirementsList requirements={requirements} />
    </div>
  );
};

export default NewPasswordFields;
